import { create } from "zustand";

export const useAppStore = create((set) => ({
	src: "",
	setSrc: (src) => set({ src }),
	srcProducts: [],
	setSrcProducts: (srcProducts) => set({ srcProducts }),
}));
